import styles from './hidden.module.scss';
import MaterialHidden from '@mui/material/Hidden';

/* eslint-disable-next-line */
export interface HiddenProps {
  children?: any,
  implementation?: 'css' | 'js',
  // initialWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl',
  lgDown?: boolean,
  lgUp?: boolean,
  mdDown?: boolean,
  mdUp?: boolean,
  // only?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | Array<'xs' | 'sm' | 'md' | 'lg' | 'xl'>,
  smDown?: boolean,
  smUp?: boolean,
  xlDown?: boolean,
  xlUp?: boolean,
  xsDown?: boolean,
  xsUp?: boolean
}

export function Hidden(props: HiddenProps) {
  return (
    <MaterialHidden
      xlDown={props.xlDown}
      xlUp={props.xlUp}
      lgDown={props.lgDown}
      lgUp={props.lgUp}
      mdDown={props.mdDown}
      mdUp={props.mdUp}
      smDown={props.smDown}
      smUp={props.smUp}
      xsDown={props.xsDown}
      xsUp={props.xsUp}>
      {props.children}
    </MaterialHidden>
  );
}

export default Hidden;